<template>
  <div class="nas">
    <v-row>
      <v-col cols="12" md="6" class="py-0">
        <v-text-field
          v-if="nasIdentifier"
          label="NAS-ID"
          v-model="parentNasForm.nasIdentifier"
          prefix="passman_"
          :rules="rules.nas_identifierRules"
          persistent-hint
          hint="Chaine de 32 caractères MAX (préfixe inclu), unique, sans caractères spéciaux et sans espace"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <v-text-field
          label="Mot de passe"
          v-model="parentNasForm.password"
          :rules="nasIdentifier ? rules.passwordRules : []"
          persistent-hint
          hint="Mdp de connection à l'administration du NAS"
        >
          <template v-slot:append-outer>
            <v-btn icon @click.stop="generateRandomPassword">
              <v-icon>mdi-shuffle</v-icon>
            </v-btn>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" class="pt-0">
        <v-text-field
          label="Description"
          v-model="parentNasForm.description"
          :rules="rules.descriptionRules"
          persistent-hint
          hint="Courte description du NAS"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6" class="pt-0">
        <v-select
          label="Type de monitoring"
          :items="monitoringTypes"
          item-text="text"
          item-value="value"
          v-model="parentNasForm.monitoringType"
        ></v-select>
      </v-col>
      <v-col cols="12" md="6" class="pt-0">
        <v-text-field
          label="IP Monitoring"
          v-model="parentNasForm.monitoringIp"
          persistent-hint
          hint="Laisser vide pour utiliser l'IP Public pour le monitoring"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6" class="pt-0">
        <v-select
          v-if="nasIdentifier"
          label="Type de NAS"
          :items="nasTypes"
          item-text="description"
          item-value="id"
          v-model="parentNasForm.nasType"
          :rules="rules.nasTypeRules"
        ></v-select>
      </v-col>
      <v-col cols="12" md="6" class="pt-0">
        <v-checkbox
          label="Actif"
          v-model="parentNasForm.active"
          persistent-hint
          hint="Pour activer le NAS"
        ></v-checkbox>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { computed, onMounted } from "@vue/composition-api";
import { useNas } from "@/composables/nas";

export default {
  props: {
    nasForm: Object,
    rules: Object,
    nasIdentifier: Boolean,
  },
  setup(props, { emit }) {
    /* Import des API */
    const { nasTypes, listNasType } = useNas();

    /* Variables */
    const monitoringTypes = [
      { text: "No Monitoring", value: 0 },
      { text: "Monitoring without client access", value: 1 },
      { text: "Monitoring with client access", value: 2 },
    ];

    /* Computed */
    const parentNasForm = computed({
      get: () => props.nasForm,
      set: (value) => {
        emit("update:nasForm", value);
      },
    });

    /* Méthodes */
    const generateRandomPassword = function () {
      let mask = "";
      const alphabet = "abcdefghijklmnopqrstuvwxyz";
      const majAlphabet = alphabet.toUpperCase();
      const digits = "0123456789";
      let result = "";
      const PSW_MAX_LENGTH = 8;

      mask = alphabet + majAlphabet + digits;
      for (let i = 0; i < PSW_MAX_LENGTH; i++) {
        result += mask[Math.floor(Math.random() * mask.length)];
      }

      const proxy = { ...parentNasForm.value };
      proxy.password = result;
      parentNasForm.value = { ...proxy };
    };

    /* Cycle de vie */
    onMounted(async () => {
      await listNasType();
      if (props.nasIdentifier == true) {
        parentNasForm.value.monitoringType = monitoringTypes[0].value;
      }
    });

    return {
      parentNasForm,
      monitoringTypes,
      nasTypes,
      generateRandomPassword,
    };
  },
};
</script>
